import { render, staticRenderFns } from "./iconCircleButton.vue?vue&type=template&id=2c55a115&scoped=true&lang=pug"
import script from "./iconCircleButton.vue?vue&type=script&lang=ts"
export * from "./iconCircleButton.vue?vue&type=script&lang=ts"
import style0 from "./iconCircleButton.vue?vue&type=style&index=0&id=2c55a115&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55a115",
  null
  
)

export default component.exports